module.exports = __webpack_public_path__ + "static/media/b-img-1.080884dc.png";